import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";

export function ActivoRegistro() {
    const navigate = useNavigate();
    const [params]  = useSearchParams();
    const idactivo  = params.get('idactivo') ?? '';

    const [codigo,       setCodigo]       = useState(params.get('codigo') ?? '');
    const [tipo,         setTipo]         = useState(params.get('tipo')   ?? '');
    const [ubicacion,    setUbicacion]    = useState('');
    const [descripcion,  setDescripcion]  = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [mensaje,      setMensaje]      = useState({ tipo: '', texto: '' });

    const handleGuardar = e => {
        e.preventDefault();
        setIsSubmitting(true);
        setMensaje({ tipo: '', texto: '' });

        fetch(process.env.REACT_APP_INVENTARIO_API_URL + 'api/etiqueta/update/' + idactivo, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ idactivo, codigo, ubicacion, tipo, descripcion }),
        })
            .then(r => r.json())
            .then(res => {
                setIsSubmitting(false);
                if (res.idetiqueta > 0) {
                    setMensaje({ tipo: 'success', texto: 'Activo registrado correctamente.' });
                    setTimeout(() => navigate(`/activo/?idactivo=${idactivo}&tipo=${tipo}&codigo=${codigo}`), 1500);
                } else {
                    setMensaje({ tipo: 'error', texto: 'Error al registrar el activo. Intente nuevamente.' });
                }
            })
            .catch(() => {
                setIsSubmitting(false);
                setMensaje({ tipo: 'error', texto: 'Error de conexión. Intente nuevamente.' });
            });
    };

    const volverUrl = `/activo/?idactivo=${idactivo}&tipo=${tipo}&codigo=${codigo}`;

    return (
        <div className="ar-page">
            <style>{`
                .ar-page {
                    max-width: 640px; margin: 0 auto;
                    padding: 1.5rem 1rem 4rem;
                    background: #f8fafc; min-height: 100vh;
                }
                @media (min-width: 768px) { .ar-page { padding: 2rem 2rem 4rem; } }

                /* ── Header ── */
                .ar-header { display:flex; align-items:flex-start; gap:1rem; margin-bottom:2rem; flex-wrap:wrap; }
                .ar-back {
                    display:inline-flex; align-items:center; gap:.35rem; flex-shrink:0;
                    color:#64748b; text-decoration:none; font-size:.82rem; font-weight:500;
                    background:#fff; border:1px solid #e2e8f0; border-radius:.5rem; padding:.45rem .9rem;
                    transition:color .15s, border-color .15s, box-shadow .15s;
                }
                .ar-back:hover { color:#c81e22; border-color:#fecaca; box-shadow:0 1px 4px rgba(200,30,34,.1); }
                .ar-title { margin:0; font-size:1.4rem; font-weight:800; color:#0f172a; letter-spacing:-.025em; line-height:1.2; }
                .ar-subtitle { font-size:.82rem; color:#334155; margin:.2rem 0 0; }

                /* ── Card ── */
                .ar-card {
                    background:#fff; border-radius:1rem; overflow:hidden;
                    border:1px solid #e2e8f0;
                    box-shadow:0 1px 3px rgba(0,0,0,.05), 0 4px 16px rgba(0,0,0,.04);
                }
                .ar-card-hdr {
                    display:flex; align-items:center; gap:.75rem;
                    padding:1rem 1.5rem; background:#fafafa; border-bottom:1px solid #f1f5f9;
                }
                .ar-card-icon {
                    width:34px; height:34px; border-radius:.5rem; flex-shrink:0;
                    display:flex; align-items:center; justify-content:center; background:#fdf2f2;
                }
                .ar-card-title { font-weight:700; font-size:.92rem; color:#0f172a; }
                .ar-card-body { padding:1.5rem; }

                /* ── Info banner ── */
                .ar-info {
                    display:flex; align-items:center; gap:.75rem;
                    background:#eff6ff; border:1px solid #bfdbfe;
                    border-radius:.75rem; padding:.85rem 1rem; margin-bottom:1.5rem;
                }
                .ar-info-dot {
                    width:34px; height:34px; border-radius:50%; background:#dbeafe;
                    display:flex; align-items:center; justify-content:center; flex-shrink:0;
                }
                .ar-info-lbl { font-size:.65rem; font-weight:700; letter-spacing:.08em; text-transform:uppercase; color:#64748b; }
                .ar-info-val { font-size:1.1rem; font-weight:800; color:#1d4ed8; letter-spacing:-.02em; }

                /* ── Alerts ── */
                .ar-alert {
                    display:flex; align-items:center; gap:.55rem;
                    border-radius:.75rem; padding:.75rem 1rem;
                    font-size:.84rem; font-weight:500; margin-bottom:1.25rem;
                }
                .ar-alert-success { background:#f0fdf4; border:1px solid #bbf7d0; color:#15803d; }
                .ar-alert-error   { background:#fff5f5; border:1px solid #fecaca; color:#b91c1c; }

                /* ── Form ── */
                .ar-row {
                    display:grid; grid-template-columns:1fr; gap:0;
                }
                @media (min-width:520px) {
                    .ar-row-2 { grid-template-columns:1fr 1fr; gap:1rem; }
                }
                .ar-field { margin-bottom:1rem; }
                .ar-label {
                    display:block; font-size:.68rem; font-weight:700;
                    letter-spacing:.08em; text-transform:uppercase; color:#334155;
                    margin-bottom:.4rem;
                }
                .ar-input-wrap { position:relative; }
                .ar-input-icon {
                    position:absolute; left:.9rem; top:50%;
                    transform:translateY(-50%); color:#94a3b8; font-size:.88rem; pointer-events:none;
                }
                .ar-input, .ar-select {
                    width:100%; padding:.75rem 1rem .75rem 2.5rem;
                    border:1.5px solid #e2e8f0; border-radius:.75rem;
                    font-size:.9rem; color:#0f172a; background:#f8fafc;
                    outline:none; appearance:none; -webkit-appearance:none;
                    transition:border-color .2s, box-shadow .2s, background .2s;
                    font-family:inherit;
                }
                .ar-input:focus, .ar-select:focus {
                    border-color:#c81e22; background:#fff;
                    box-shadow:0 0 0 3px rgba(200,30,34,.1);
                }
                .ar-input::placeholder { color:#cbd5e1; }
                .ar-select { cursor:pointer; }
                .ar-select option { color:#0f172a; }

                /* ── Divider ── */
                .ar-divider { border:none; border-top:1px solid #f1f5f9; margin:1.35rem 0; }

                /* ── Button ── */
                .ar-btn {
                    display:flex; align-items:center; justify-content:center; gap:.6rem;
                    width:100%; padding:.95rem;
                    background:linear-gradient(135deg, #c81e22, #83090b);
                    color:#fff; font-size:.95rem; font-weight:700;
                    border:none; border-radius:.875rem; cursor:pointer;
                    box-shadow:0 4px 16px rgba(200,30,34,.28);
                    transition:transform .15s, box-shadow .2s;
                }
                .ar-btn:not(:disabled):hover { transform:translateY(-1px); box-shadow:0 6px 22px rgba(200,30,34,.4); }
                .ar-btn:disabled { opacity:.65; cursor:not-allowed; }
            `}</style>

            {/* ── Header ── */}
            <div className="ar-header">
                <Link to={volverUrl} className="ar-back">
                    <i className="bi bi-arrow-left"></i> Volver
                </Link>
                <div>
                    <h1 className="ar-title">Registro de activo</h1>
                    <p className="ar-subtitle">Complete la información para registrar la etiqueta en el sistema.</p>
                </div>
            </div>

            {/* ── Card ── */}
            <div className="ar-card">
                <div className="ar-card-hdr">
                    <div className="ar-card-icon">
                        <i className="bi bi-tag-fill" style={{ color:'#c81e22', fontSize:'.9rem' }}></i>
                    </div>
                    <span className="ar-card-title">Datos del activo</span>
                </div>

                <div className="ar-card-body">

                    {/* ID banner */}
                    <div className="ar-info">
                        <div className="ar-info-dot">
                            <i className="bi bi-qr-code" style={{ color:'#1d4ed8', fontSize:'.95rem' }}></i>
                        </div>
                        <div>
                            <div className="ar-info-lbl">ID de etiqueta</div>
                            <div className="ar-info-val">#{idactivo}</div>
                        </div>
                    </div>

                    {/* Alert */}
                    {mensaje.tipo && (
                        <div className={`ar-alert ar-alert-${mensaje.tipo}`}>
                            <i className={`bi ${mensaje.tipo === 'success' ? 'bi-check-circle-fill' : 'bi-exclamation-circle-fill'} flex-shrink-0`}></i>
                            {mensaje.texto}
                        </div>
                    )}

                    {/* Código + Tipo */}
                    <div className="ar-row ar-row-2">
                        <div className="ar-field">
                            <label className="ar-label">Código</label>
                            <div className="ar-input-wrap">
                                <i className="bi bi-upc-scan ar-input-icon"></i>
                                <input
                                    className="ar-input"
                                    placeholder="Ej. HAG-001"
                                    value={codigo}
                                    onChange={e => setCodigo(e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="ar-field">
                            <label className="ar-label">Tipo</label>
                            <div className="ar-input-wrap">
                                <i className="bi bi-tag ar-input-icon"></i>
                                <select
                                    className="ar-select"
                                    value={tipo}
                                    onChange={e => setTipo(e.target.value)}
                                >
                                    <option value="">Seleccione...</option>
                                    <option value="flota">Flota</option>
                                    <option value="general">General</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    {/* Ubicación */}
                    <div className="ar-field">
                        <label className="ar-label">Ubicación</label>
                        <div className="ar-input-wrap">
                            <i className="bi bi-geo-alt ar-input-icon"></i>
                            <input
                                className="ar-input"
                                placeholder="Ej. Patio norte, bahía 3"
                                value={ubicacion}
                                onChange={e => setUbicacion(e.target.value)}
                            />
                        </div>
                    </div>

                    {/* Descripción */}
                    <div className="ar-field">
                        <label className="ar-label">Descripción</label>
                        <div className="ar-input-wrap">
                            <i className="bi bi-card-text ar-input-icon"></i>
                            <input
                                className="ar-input"
                                placeholder="Descripción detallada del activo"
                                value={descripcion}
                                onChange={e => setDescripcion(e.target.value)}
                            />
                        </div>
                    </div>

                    <hr className="ar-divider" />

                    <button className="ar-btn" onClick={handleGuardar} disabled={isSubmitting}>
                        {isSubmitting ? (
                            <><span className="spinner-border spinner-border-sm" role="status"></span> Guardando...</>
                        ) : (
                            <><i className="bi bi-check2-circle"></i> Guardar activo</>
                        )}
                    </button>
                </div>
            </div>
        </div>
    );
}
